import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;

  margin-bottom: ${theme.spacings.bit};

  .ais-HierarchicalMenu-item {
    .ais-HierarchicalMenu-label {
      color: ${theme.colors.n700};
      font-weight: inherit;
      font-size: ${theme.typography.subHeadings.mega.fontSize};
      line-height: ${theme.typography.subHeadings.mega.lineHeight};
      margin-bottom: 0;
      display: inline-block;
      margin-right: ${theme.spacings.bit};
    }

    .ais-HierarchicalMenu-count {
      display: inline-block;
      padding-top: calc((${theme.spacings.bit} / 2) - 1px);
      padding-right: ${theme.spacings.byte};
      padding-bottom: calc(${theme.spacings.bit} / 2);
      padding-left: ${theme.spacings.byte};
      font-size: ${theme.typography.subHeadings.kilo.fontSize};
      line-height: ${theme.typography.subHeadings.kilo.lineHeight};
      font-weight: ${theme.font.weight.bold};
      text-align: center;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border-radius: ${theme.borderRadius.tera};
      -webkit-transition: background 200ms;
      transition: background 200ms;
      color: ${theme.colors.n700};
      background-color: ${theme.colors.n100};
    }
  }

  .ais-HierarchicalMenu-item.ais-HierarchicalMenu-item--selected {
    font-weight: ${theme.font.weight.bold};
  }

  .ais-HierarchicalMenu-link:after {
    filter: grayscale(100%);
  }

  .ais-HierarchicalMenu-showMore,
  .ais-Menu-showMore,
  .ais-RefinementList-showMore {
    padding: 0;
    font-size: ${theme.typography.subHeadings.mega.fontSize};
    line-height: ${theme.typography.subHeadings.mega.lineHeight};

    font-weight: ${theme.font.weight.bold};
    color: ${theme.colors.p700};
    background-color: unset;
    opacity: 1;

    &:hover,
    &:focus {
      background-color: unset;
    }
  }

  .ais-HierarchicalMenu-showMore--disabled {
    display: none;
  }
`

export const Wrapper = styled('div')(wrapperStyles)
